<template>
  <manageOrgchart/>
</template>

<script>
import manageOrgchart from '@/components/_managelineofwork/manageOrgchart.vue'
export default {
  components: {
    manageOrgchart
  }
}
</script>
